import BulmaExtensions from 'bulma-extensions';

const init = function () {
  const quickviews = BulmaExtensions.bulmaQuickview.attach();

  if (quickviews) {
    let quickview_closer = document.createElement("div");
    quickview_closer.id = "quickviewCloser";
    quickview_closer.setAttribute("data-dismiss", "quickview");
    document.body.appendChild(quickview_closer);

    // timeout: see -> https://github.com/Wikiki/bulma-quickview/issues/11
    setTimeout(() => {
      quickviews.forEach((quickview) => {
        quickview.on("quickview:show", function () {
          quickview_closer.style.display = "block";
        });
        quickview.on("quickview:hide", function () {
          quickview_closer.style.display = "none";
        });
      });
    }, 105);
  }
};
document.addEventListener("DOMContentLoaded", init, false);
